/**
 * Tour event bus — shared by the guided-tour engine and any other subscriber
 * (e.g. the self-serve setup checklist auto-detector).
 *
 * Keeping this in its own module breaks the would-be circular dependency
 * between use-guided-tour (which imports use-setup-guide) and use-setup-guide
 * (which needs to subscribe to tour events).
 */

export interface TourEventPayload {
  quoteId?: number;
  invoiceId?: number;
}

export type TourListener = (
  name: string,
  payload: TourEventPayload | undefined,
  gen: number,
) => void;

const listeners = new Set<TourListener>();

/** Monotonically increasing per-emission counter. */
let emitGen = 0;

export function emitTourEvent(name: string, payload?: TourEventPayload): void {
  const gen = ++emitGen;
  for (const fn of listeners) fn(name, payload, gen);
}

export function subscribeTourEvents(fn: TourListener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
